const FILE_TYPES_SIZE_MAPPING: Record<string, any> = {
  gameBackground: 1024 * 1024 * 5,
  gameSettings: 1024 * 1024 * 1.5,
  favicon: 1024 * 100,
  audio: 1024 * 1024 * 5
};

export default FILE_TYPES_SIZE_MAPPING;
